import React, { useState } from 'react'
import { Button, Input, Typography, Space } from 'antd'
import { actions } from "../contexts/properties/actions";
import { usePropertiesDispatch } from "../contexts/properties";

const { TextArea } = Input;

function ContactCard() {

  const [submitted, setSubmitted] = useState<boolean>(false)

  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [description, setDescription] = useState('')

  const dispatch = usePropertiesDispatch();

  const handleSubmit = async () => {
    const body = {
      email,
      phone,
      description
    }
    const submittedForm = await actions.postContact(dispatch, { fields: body })
    submittedForm && setSubmitted(true)
  }

  return (
    <>
      {submitted ?
        <div style={{ textAlign: 'center', backgroundColor: '#001B71', padding:20 }}>
          <Typography.Title style={{ color: '#FFFFFF' }} level={2}>Thank you for your submission!</Typography.Title>
          <Typography.Title style={{ color: '#FFFFFF' }} level={4}>We will be in touch with you shortly.</Typography.Title>
        </div>
        :
        <div style={{ backgroundColor: '#001B71', padding: '10px 10px 20px 10px' }}>
          <div style={{ padding: 20 }}>
            <Typography.Title style={{ color: '#FFFFFF' }} level={3}>Didn’t find what you’re looking for? Let us help you find a property that fits your needs!</Typography.Title>
          </div>
          <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
            <Input style={{ marginTop: 5, width:'20rem' }} placeholder="Email" onChange={(e: any) => setEmail(e.target.value)} />
            <Input style={{ marginTop: 5, width:'20rem' }} placeholder="Phone" onChange={(e: any) => setPhone(e.target.value)} />
            <TextArea style={{ resize: 'none', marginTop: 5, width:'20rem' }} rows={4} placeholder="Tell us more about the kind of property you’re looking for..." onChange={(e: any) => setDescription(e.target.value)} />
          </div>
            <Button style={{ marginTop: 5 }} type='primary' onClick={handleSubmit}>Submit</Button>
        </div>
      }
    </>
  )
}

export default ContactCard